import { useState, type FormEvent } from 'react';
import { supabase } from '@/lib/supabase';
import { LivePill } from '@/components/ui';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setBusy(false);
    if (error) setError(error.message);
  }

  return (
    <div className="grid h-full place-items-center px-4">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm rounded-[10px] border border-line bg-bg-1 p-6 shadow-2xl"
      >
        <div className="mb-1 flex items-center gap-3">
          <span className="text-[20px] font-bold leading-none text-green">▽</span>
          <span className="text-[14px] font-extrabold tracking-wordmark">VALEXOS</span>
          <LivePill>VERITAS</LivePill>
        </div>
        <div className="mb-6 mt-2 text-[12px] text-text-dim">
          Sign in to view live MT5 account data.
        </div>

        <label className="mb-3 block text-sm">
          <div className="mb-1 text-[10px] font-bold uppercase tracking-eyebrow text-text-dim">Email</div>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            className="w-full rounded-md border border-line bg-bg-2 px-3 py-2 text-[13px] text-text outline-none transition-colors placeholder:text-text-faint focus:border-green"
          />
        </label>

        <label className="mb-5 block text-sm">
          <div className="mb-1 text-[10px] font-bold uppercase tracking-eyebrow text-text-dim">Password</div>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            className="w-full rounded-md border border-line bg-bg-2 px-3 py-2 text-[13px] text-text outline-none transition-colors placeholder:text-text-faint focus:border-green"
          />
        </label>

        {error && (
          <div className="mb-4 rounded border border-red/40 bg-red/10 px-3 py-2 text-[12px] text-red">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={busy}
          className="w-full rounded-md bg-green py-2 text-[13px] font-semibold text-bg transition-opacity hover:opacity-90 disabled:opacity-50"
        >
          {busy ? 'Signing in…' : 'Sign in'}
        </button>

        <div className="mt-4 text-center text-[10.5px] text-text-dim">
          Admin user must be created in Supabase Dashboard → Authentication → Users.
        </div>
      </form>
    </div>
  );
}
